import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useShouldDisplayOrderStatus from '~/hooks/vdp/selectors/useShouldDisplayOrderStatus';
import useAlertStatus from './useAlertStatus';
import useShowOutOfAreaError from './useShowOutOfAreaError';

export default function useShouldShowPriceDetails() {
  const { isSold, otherUnavailable } = useAlertStatus();
  const { price = 0 } = useGetVehicleDetails();
  const shouldDisplayOrderStatus = useShouldDisplayOrderStatus();
  const showOutOfAreaError = useShowOutOfAreaError();
  const shouldShowPriceDetails = !showOutOfAreaError && price > 0;

  return (
    shouldDisplayOrderStatus ||
    (shouldShowPriceDetails && !isSold && !otherUnavailable)
  );
}
